
const LOCALHOST = 'localhost'
const RANCHER_DESENVOL = 'http://mapa.desenvol.rancher.tcu.gov.br'
const RANCHER_ACEITE = 'http://mapa.aceite.rancher.tcu.gov.br'
const RANCHER_PRODUCAO = 'http://mapa.producao.rancher.tcu.gov.br'
const APPS_PRODUCAO = 'https://mapa.apps.tcu.gov.br'

export function isDesenvol() {
  const { href } = window.location
  return href.startsWith(RANCHER_DESENVOL) || href.includes(LOCALHOST)
}

export function isAceite() {
  const { href } = window.location
  return href.startsWith(RANCHER_ACEITE)
}

export function isProducao() {
  const { href } = window.location
  return href.startsWith(RANCHER_PRODUCAO) || href.startsWith(APPS_PRODUCAO)
}
